import React from 'react'

type Props = {
  className?: string
}

const Stock = ({ className }: Props) => (
  <svg width="64" height="65" viewBox="0 0 64 65" fill="none" className={className}>
    <rect y="0.702637" width="64" height="64" rx="20" fill="#D8E6FF" />
    <path
      d="M37.3333 20.7026H17.3333V38.036H37.3333V20.7026Z"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.3333 27.3693H42.6666L46.6666 31.3693V38.036H37.3333V27.3693Z"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.3333 44.7026C25.1743 44.7026 26.6667 43.2102 26.6667 41.3693C26.6667 39.5283 25.1743 38.036 23.3333 38.036C21.4924 38.036 20 39.5283 20 41.3693C20 43.2102 21.4924 44.7026 23.3333 44.7026Z"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.6666 44.7026C42.5076 44.7026 44 43.2102 44 41.3693C44 39.5283 42.5076 38.036 40.6666 38.036C38.8257 38.036 37.3333 39.5283 37.3333 41.3693C37.3333 43.2102 38.8257 44.7026 40.6666 44.7026Z"
      stroke="#2979FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Stock
